"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Reel = /** @class */ (function () {
    function Reel(offpageCanvasArray, offpageCanvasWidth, offpageCanvasHeight) {
        this.offpageCanvasArray = offpageCanvasArray;
        this.reelFrames = document.getElementsByClassName('reel-frame');
        this.offpageCanvasWidth = offpageCanvasWidth;
        this.offpageCanvasHeight = offpageCanvasHeight;
    }
    Reel.prototype.generateReel = function () {
        for (var i = 0; i < this.offpageCanvasArray.length; i++) {
            var reelFrame = this.reelFrames[i];
            var offpageFrame = this.offpageCanvasArray[i];
            reelFrame.width = 300;
            reelFrame.height = 225;
            var canvasContext = reelFrame.getContext('2d');
            canvasContext.drawImage(offpageFrame, 0, 0, this.offpageCanvasWidth, this.offpageCanvasHeight, 0, 0, 300, 225);
        }
    };
    return Reel;
}());
exports.default = Reel;
